module.exports = __webpack_public_path__ + "img/d.9148c54d.png";